import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getTierStreamId } from '../helpers';
export default function*() {
    const streamId = getTierStreamId();
    const isFetching = yield select(selectors.isFetching, streamId);
    if (isFetching) {
        return;
    }
    yield put(withOffset.actions.fetch(streamId));
}
